import { MatDialog } from '@angular/material/dialog';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ViewChildren,
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { DataSource } from '@angular/cdk/collections';
import { AsDocumenttypeService } from 'src/app/core/services/as-document-type.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import {
  Subscription,
  BehaviorSubject,
  Observable,
  merge,
  Subject,
  forkJoin
} from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

import {
  animate,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { debounceTime, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { ViewPdfComponent } from 'src/app/shared/components/view-pdf/view-pdf.component';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { Message } from 'src/app/core/class/message';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentTemplate } from 'src/app/shared/models/document-template.model';
import { DocumentTemplateGetAll } from 'src/app/core/models/document-template-get-all.model';
import { FormControl, FormGroup } from '@angular/forms';
import { Paginate } from 'src/app/core/class/paginate';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DialogPreviewPdfComponent } from '../dialog-preview-pdf/dialog-preview-pdf.component';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { PermissionConfig } from 'src/app/core/constants/permission-config';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { ResponsiveService } from './../../../../../../core/services/responsive.service';
import { SearchDocumentComponent } from '../../document/search-document/search-document.component';
import { SearchDocumentTemplateComponent } from '../search-document-template/search-document-template.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-list-document-template',
  templateUrl: './list-document-template.component.html',
  styleUrls: ['./list-document-template.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'void',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListDocumentTemplateComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('focusInput') focusInput;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    private documentTemplateService: DocumentTemplateService,
    public documentTypeService: DocumentTypeService,
    public templateFileService: TemplateFileService,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private notificationService: NotificationService,
    private responsiveService: ResponsiveService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.route.queryParams.subscribe(queryparams => {
      this.documentTemplate = {
        nameOrCode: queryparams.nameOrCode ? queryparams.nameOrCode : null,
        serviceType: queryparams.serviceType ? queryparams.serviceType : null,
        status: queryparams.status ? queryparams.status : null,
        isDraft: queryparams.isDraft ? queryparams.isDraft : null,
        page: queryparams.page ? queryparams.page : 0,
        size: queryparams.size ? queryparams.size : 10,
      };
    });
  }

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  // displayedColumns: string[] = [
  //   'stt', // số thứ tự
  //   'code', // mã mẫu tài liệu,
  //   'name', // tên mẫu tài liệu
  //   'type', // loại hợp đồng
  //   'status', // trạng thái
  //   'action', // thao tác
  // ];

  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: "stt", showMobile: true },
    { def: "name", showMobile: true },
    { def: "code", showMobile: true },
    { def: "type", showMobile: false },
    { def: "status", showMobile: false },
    { def: "action", showMobile: true }
  ];

  documents = {
    name: '',
    type: null,
    status: null,
  };

  /* parentDataSource = new MatTableDataSource(); */
  parentDataSource: DocumentTemplateDataSource;

  oldData = this.documents;
  error = '';
  subscription: Subscription;
  pageNo: number;
  parentDocumentTypes: DocumentType[];
  expanded = [];
  openedRow: CdkDetailRowDirective;
  sortDirection = 'ASC';
  sortColumn = 'name';
  isFirstLoad = true;

  searchDocumentForm: FormGroup;
  listTypes: Observable<any>;
  listServiceTypes: any[] = [];
  searchTypeCtrl: FormControl = new FormControl(null);
  loadingSearchType = false;
  _onDestroy = new Subject<void>();

  // parentPaginate: Paginate;

  documentTemplate = {
    nameOrCode: null,
    serviceType: null,
    status: null,
    isDraft: null,
    page: 0,
    size: 10,
  };

  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  };

  ngOnInit() {
    // this.serviceTypeService
    //   .filterServiceTypes({
    //     ...this.documents,
    //     ...this.paginate,
    //     page: this.paginate.currentPage,
    //   })
    //   .subscribe((result) => {
    //     const { data } = result;
    //     this.listTypes = data.dataRow;
    //   });
    this.getServiceType();
    this.parentDataSource = new DocumentTemplateDataSource();
    this.loadData(this.documentTemplate);
    let status = null;
    if (this.documentTemplate.isDraft && JSON.parse(this.documentTemplate.isDraft)) {
      status = 'DRAFT';
    } else if (this.documentTemplate.status && JSON.parse(this.documentTemplate.status) === false) {
      status = 'INACTIVE';
    } else if (this.documentTemplate.status && JSON.parse(this.documentTemplate.status) === true) {
      status = 'ACTIVE';
    }

    this.searchDocumentForm = new FormGroup({
      codeOrNameContains: new FormControl(this.documentTemplate.nameOrCode),
      typeContains: new FormControl(this.documentTemplate.serviceType ? Number(this.documentTemplate.serviceType) : null),
      statusEquals: new FormControl(status),
    });

    // this.subscribeErrorService();
    window.scrollTo(0, 0);
    this.documentTemplateService.typeforUpdateDocumentPage.next('');
    this.searchDocumentType();

    this.notificationService.subscribeErrorService();

    this.documentTemplateService.downloadTemplateSuccess.asObservable().subscribe(rs => {
      if(rs){
        this.loadData(this.documentTemplate);
      }
    })
  }

  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    // this.unsubscribeErrorService();
    // this.notificationService.subscribeErrorService();

  }

  /**
   * Get data when init
   */
  loadData(request: any) {
    this.documentTemplateService
      .getDocumentTemplate(request)
      .subscribe((response) => {
        if (!response || !response.data) {
          return;
        }
        this.parentDataSource.setData(response.data.content);
        this.paginate = {
          currentPage: response.data.pageable.page,
          pageSize: response.data.pageable.size,
          totalRow: response.data.total,
          totalPage: Math.ceil(
            response.data.total / response.data.pageable.size
          ),
          totalPageArray: this.commonService.counter(
            Math.ceil(response.data.total / response.data.pageable.size),
            1
          ),
          no: this.commonService.counter(
            response.data.pageable.size,
            response.data.pageable.page * response.data.pageable.size + 1
          ),
        };
      });
  }

  /**
   * Filter data with condition
   */
  onClickBtnFilter() {
    const temp = this.documentControls.statusEquals.value;
    if (temp === 'DRAFT') {
      this.documentTemplate.isDraft = true;
      this.documentTemplate.status = null;
    } else if (temp === 'ACTIVE') {
      this.documentTemplate.status = true;
      this.documentTemplate.isDraft = false;
    } else if (temp === 'INACTIVE') {
      this.documentTemplate.status = false;
      this.documentTemplate.isDraft = false;
    } else {
      this.documentTemplate.status = null;
      this.documentTemplate.isDraft = null;
    }
    this.documentTemplate.nameOrCode = this.documentControls.codeOrNameContains
      .value
      ? this.documentControls.codeOrNameContains.value
      : null;
    this.documentTemplate.serviceType = this.documentControls.typeContains.value
      ? this.documentControls.typeContains.value
      : null;
    this.documentTemplate.page = 0;
    this.documentTemplate.size = 10;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.documentTemplate,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      skipLocationChange: false
    });
    // this.loadData(this.documentTemplate);
  }

  get documentControls() {
    return this.searchDocumentForm.controls;
  }

  onClickCreateField() {
    // if(Number(localStorage.getItem('userType')) !== PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE) {
    //   this.toast.error(this.message.getMessage('messages.check_permission'));
    //   return;
    // }
    const documentTemplate: DocumentTemplate = DocumentTemplate.build();
    documentTemplate.status = false;
    documentTemplate.isDraft = true;

    this.documentTemplateService
      .saveDocumentTemplate(documentTemplate)
      .subscribe((response) => {
        if (response && response.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!response || !response.data) {
          return;
        }
        this.documentTemplateService.typeforUpdateDocumentPage.next('create');
        const link = `/home-enterprise/document-template/update/${response.data.id}`;
        this.router.navigateByUrl(link);
      });
  }

  deleteDocument(data: DocumentTemplate) {
    const content = this.commonService.format(
      this.message.getMessage('messages.confirm_delete_template'),
      data.name
    );
    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: content,
    });
    dialog.afterClosed().subscribe((ref) => {
      if (ref) {
        this.documentTemplateService
          .deleteDocumentTemplate(data.id)
          .subscribe((res) => {
            if (res && res.code === ErrorCode.NotPermissionTemplate) {
              this.toast.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (!res || !res.data) {
              this.toast.error(this.message.getMessage(
                'messages.delete_document_template_error'
              ));
              return;
            }
            this.toast.success(
              this.message.getMessage(
                'messages.delete_document_template_success'
              )
            );
            if (this.paginate.totalRow % this.paginate.pageSize === 1 && this.paginate.currentPage === this.paginate.totalPage - 1) {
              this.documentTemplate.size = this.paginate.pageSize;
              this.documentTemplate.page = this.paginate.currentPage ? this.paginate.currentPage - 1 : 0;
            }
            this.loadData(this.documentTemplate);
          });
      }
    });
  }

  editDocument(data: DocumentTemplate) {
    this.documentTemplateService.getDocumentTemplateById(data.id).subscribe(res => {
      if (res && res.code === ErrorCode.NotPermissionTemplate) {
        this.toast.error(this.message.getMessage('messages.check_permission'));
        return;
      }
      if (!res || !res.data) {
        return;
      }
      const link = `/home-enterprise/document-template/update/${data.id}`;
      this.router.navigateByUrl(link);
    });
  }

  changeStatus(data: DocumentTemplate) {
    this.documentTemplateService.getDocumentTemplateById(data.id).subscribe(resDT => {
      if (resDT && resDT.code === ErrorCode.NotPermissionTemplate) {
        this.toast.error(this.message.getMessage('messages.check_permission'));
        return;
      }
      if (!resDT || !resDT.data) {
        return;
      }
      let titleDialog;
      if (data.status) {
        titleDialog = this.commonService.format(
          this.message.getMessage("messages.confirm_change_status_inactive"),
          data.name
        );
      } else {
        titleDialog = this.commonService.format(
          this.message.getMessage("messages.confirm_change_status_active"),
          data.name
        );
      }

      const warnDialog = this.dialog.open(WarningComponent, {
        width: "40%",
        data: titleDialog,
      });

      warnDialog.afterClosed().subscribe((ref) => {
        if (ref) {
          let request = {
            id: data.id,
            status: false
          }
          if (data.status) {
            this.documentTemplateService
              .activeDocumentTemplate(request)
              .subscribe((res) => {
                if (res && res.code === ErrorCode.NotPermissionTemplate) {
                  this.toast.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                this.toast.success(
                  this.message.getMessage("messages.change_status_success")
                );
                this.loadData(this.documentTemplate);
              });
          } else {
            request.status = true;
            this.documentTemplateService
              .activeDocumentTemplate(request)
              .subscribe((res) => {
                if (res && res.code === ErrorCode.NotPermissionTemplate) {
                  this.toast.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                this.toast.success(
                  this.message.getMessage("messages.change_status_success")
                );
                this.loadData(this.documentTemplate);
              });
          }
        }
      });
    })
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };
    this.documentTemplate.page = this.paginate.currentPage;
    this.documentTemplate.size = this.paginate.pageSize;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.documentTemplate,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      skipLocationChange: false
    });
    // this.loadData(this.documentTemplate);
  }

  renderServiceType(serviceTypeId: number): string {
    const serviceType =this.listServiceTypes ? this.listServiceTypes.find(
      (type) => type.id === serviceTypeId
    ) : {};
    if (serviceType && serviceType.name) {
      return serviceType.name;
    }
    return '';
  }

  getTooltip(template: DocumentTemplate): string {
    if (template.isDraft) {
      return this.message.getMessage('document_template.tooltip_draft');
    }
    if (template.status) {
      return this.message.getMessage('document_template.tooltip_active');
    }
    return this.message.getMessage('document_template.tooltip_inactive');
  }

  getTooltipPreview(element: DocumentTemplate) {
    if (!element.isDraft) {
      return this.message.getMessage('document_template.tooltip_preview');
    } else {
      return '';
    }
  }

  preview(element: DocumentTemplate) {
    this.documentTypeService.checkPermission(element.id).subscribe(rs => {
      if (rs && rs.success) {
        if (rs && rs.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        this.templateFileService.getTemplateFile(element.documentTemplateId)
          .subscribe((res) => {
            if (res.data[0]) {
              this.templateFileService.getContentFileByUrl({
                type: 'TEMPLATE_PDF',
                url: res.data[0].file.pdfUrl,
              }).subscribe((response) => {
                if (!response) {
                  return;
                }
                this.dialog.open(DialogPreviewPdfComponent, {
                  width: '80%',
                  data: {
                    file: response,
                    name: element.name,
                  },
                });
              });
            }
          });
      }
    });

  }

  getServiceType(): void {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.documentTypeService
      .getServiceTypesAll(enterpriseId)
      .subscribe((result) => {
        const { data } = result;
        this.listServiceTypes = data;
        this.searchTypeCtrl.patchValue('');
      });
  }

  searchDocumentType() {
    // listen for search field value changes
    this.listTypes = this.searchTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map((value) => {
          if (!value) {
            return this.listServiceTypes;
          }
          return this.listServiceTypes.filter((st) => {
            const optionLabel = `${st.name}`;
            return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
          });
        })
      );
  }

  copyDocumentTemplate(documentTemplate: DocumentTemplate) {
    this.documentTemplateService
      .copyDocumentTemplate(documentTemplate.id)
      .subscribe((response) => {
        if (response && response.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!response || !response.data) {
          return;
        }
        this.documentTemplateService.typeforUpdateDocumentPage.next('create');
        const link = `/home-enterprise/document-template/update/${response.data.id}`;
        this.router.navigateByUrl(link);
      });
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName('cell');
    if (elmsSpan.item(index).scrollWidth > elmsCell.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  focusOut(field: string) {
    this.documentControls[field].patchValue(this.documentControls[field].value ? this.documentControls[field].value.trim() : null);
  }

  clearData(field: string) {
    this.documentControls[field].patchValue(null);
  }

  onClickSearchDocument() {
    // this.blockUI.reset();
    // this.blockUI.start('');
    let body = {
      name: '',
      page: 0,
      size: 10
    }
    forkJoin({
      systemTemplates: this.documentTypeService.systemGetAll({...body, realm: ''}),
      syncTemplates: this.documentTypeService.syncGetAll(body)
    }).subscribe(rs => {
      this.dialog.open(SearchDocumentTemplateComponent,
        {
          width: '80%',
          data: rs
        })
    })
    
  }
}

export class DocumentTemplateDataSource extends DataSource<DocumentTemplate> {
  /** Stream of data that is provided to the table. */
  private data = new BehaviorSubject<DocumentTemplate[]>([]);
  private loading = new BehaviorSubject<boolean>(false);

  public loading$ = this.loading.asObservable();

  constructor() {
    super();
  }

  // indicate is loading
  startLoadData() {
    this.loading.next(true);
  }

  setData(data: DocumentTemplate[]) {
    /* this.data = new BehaviorSubject<DocumentType[]>(data); */
    this.data.next(data);
    this.loading.complete();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DocumentTemplate[]> {
    /* return this.data; */
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
    this.loading.complete();
  }
}
